module.exports = __webpack_public_path__ + "img/head5.71eb21bc.png";